import { Action } from '@ngrx/store';
import {SpinnerItem} from  './spinner.state';

export const SPINNER_VISIBLE			  = '[Spinner] Visibile ';
export const SPINNER_HIDDEN 	          = '[Spinner] Hidden ';


export class SpinnerVisible implements Action {
	readonly type = SPINNER_VISIBLE;
    constructor(readonly payload: SpinnerItem) { }
}

export class SpinnerHidden implements Action {
	readonly type = SPINNER_HIDDEN;
    constructor(readonly payload: SpinnerItem) { }
}



export type Actions = SpinnerVisible | SpinnerHidden;
